import MisoSDKClient, { MisoItem, MisoResponse } from '@miso.ai/client-sdk';

// The number of items we want Miso to send back when making recommendations.
// We need to filter for eligibility client-side at this time, so let's just
// grab way more than we need, in case a bunch of them aren't eligible.
const PRODUCT_TO_PRODUCT_ROWS = 100;

const SEARCH_ROWS = 250;

const PUBLISHABLE_MISO_API_KEY =
  process.env.REACT_APP_PUBLISHABLE_MISO_API_KEY || 'API_KEY_UNSET';

class MisoClient {
  private _client: MisoSDKClient;

  constructor(publishable_api_key: string) {
    this._client = new MisoSDKClient(publishable_api_key);
  }

  public async getProductToProductRecommendations({
    user_hash,
    product_id,
  }: {
    product_id: string;
    user_hash: string;
  }): Promise<Array<MisoItem>> {
    const response: MisoResponse =
      await this._client.api.recommendation.productToProducts({
        product_id,
        user_hash,
        rows: PRODUCT_TO_PRODUCT_ROWS,
      });

    return response.products;
  }

  public async getUserToProductRecommendations(
    user_hash: string
  ): Promise<Array<MisoItem>> {
    const response: MisoResponse =
      await this._client.api.recommendation.userToProducts({
        user_hash,
        rows: PRODUCT_TO_PRODUCT_ROWS,
      });

    return response.products;
  }

  public async semanticSearch(query_term: string): Promise<Array<MisoItem>> {
    const response = await this._client.api.search.search(
      {
        q: query_term,
        rows: SEARCH_ROWS,
        enable_partial_match: true,
        enable_semantic_search: true,
      },
      {}
    );

    return response.products;
  }
}

const misoClient = new MisoClient(PUBLISHABLE_MISO_API_KEY);

export default misoClient;
